<!--
 * @Author: wyq
 * @Date: 2021-07-23 10:00:14
 * @LastEditTime: 2021-07-23 10:47:27
 * @LastEditors: wyq
 * @Description: 
 * @FilePath: \knowledge_building_system\src\components\el\footer.vue
-->
<template>
  <footer class="el-footer" :style="{ height }">
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: 'ElFooter',

  componentName: 'ElFooter',

  props: {
    height: {
      type: String,
      // default: '60px',
    },
  },
}
</script>
<style lang="scss" scoped>
.el-footer {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
</style>